import { E as r } from "./events.Dnaewmpi.min.js";
import { S as a } from "./sections-api-service.smvSsykG.min.js";
import { p as n } from "./parse-html.C-hh7jJd.min.js";
import { priceFacetChipRedundantFromUrl } from "./price-filter-url.js";

class c extends HTMLElement {
  constructor() {
    (super(), (this.track = this.querySelector("[data-filter-chips]")));
  }

  prunePriceChipIfNoPriceParams() {
    const url = new URL(window.location.href);
    const slider =
      document.querySelector("filters-facets price-slider") ||
      document.querySelector('price-slider[data-component="price-slider"]');
    this.querySelectorAll("[data-filter-chip][data-filter-params]").forEach(
      (chip) => {
        const raw = chip.getAttribute("data-filter-params") || "";
        const params = raw
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
        if (!params.length) {
          return;
        }
        const isPrice = params.some(
          (p) =>
            p.includes("price") ||
            p.includes(".price.") ||
            p.includes("filter.v.price"),
        );
        if (!isPrice) {
          return;
        }
        const hasParam = params.some((p) => url.searchParams.has(p));
        if (!hasParam) {
          chip.remove();
          return;
        }
        if (!slider) {
          return;
        }
        let gteRaw = null;
        let lteRaw = null;
        for (const p of params) {
          if (!url.searchParams.has(p)) {
            continue;
          }
          if (p.endsWith(".gte") || p.includes(".price.gte")) {
            gteRaw = url.searchParams.get(p);
          }
          if (p.endsWith(".lte") || p.includes(".price.lte")) {
            lteRaw = url.searchParams.get(p);
          }
        }
        if (
          priceFacetChipRedundantFromUrl(
            slider.dataset.min,
            slider.dataset.max,
            gteRaw,
            lteRaw,
          )
        ) {
          chip.remove();
        }
      },
    );
    this.refreshAppliedFiltersMeta();
  }

  refreshAppliedFiltersMeta() {
    const track = this.querySelector(".filter-chips[data-filter-chips]");
    const count = track
      ? track.querySelectorAll("[data-filter-chip]").length
      : 0;
    this.setAttribute("data-active", count > 0 ? "true" : "false");
    const hidden = this.querySelector("#filterCount");
    if (hidden) {
      hidden.value = String(count);
    }
    const heading = this.querySelector(".filter-drawer__chips-heading");
    const tpl = window.strings?.products?.facets?.applied_filters_template;
    if (heading && tpl) {
      heading.textContent = tpl.replace("__COUNT__", String(count));
    }
    const mobileCount = document.querySelector("#filterCountData");
    if (mobileCount) {
      mobileCount.textContent = count > 0 ? `(${count})` : "";
    }
  }

  syncCustomLinkedSliderChips() {
    let track = this.querySelector(".filter-chips[data-filter-chips]");
    if (!track) {
      track = this.querySelector("[data-filter-chips]");
    }

    if (!track) {
      return;
    }

    track.querySelectorAll('[data-linked-filter-chip="true"]').forEach((chip) => {
      chip.remove();
    });

    const currentUrl = new URL(window.location.href);
    const sliderButtons = document.querySelectorAll(
      ".linked-collections-slider [data-filter-button]",
    );
    const customFilters = [];

    const resolveFilterTarget = (button) => {
      const fallbackName = button.getAttribute("data-filter-param");
      const fallbackValue = button.getAttribute("data-filter-value");
      const filterUrl = button.getAttribute("data-filter-url");

      if (!filterUrl) {
        return { filterName: fallbackName, filterValue: fallbackValue };
      }

      try {
        const parsed = new URL(filterUrl, window.location.origin);
        const entries = Array.from(parsed.searchParams.entries());
        const matchedEntry = entries.find(([key]) =>
          key.startsWith("filter.") || key.startsWith("f_"),
        );

        if (matchedEntry) {
          return { filterName: matchedEntry[0], filterValue: matchedEntry[1] };
        }
      } catch (error) {
        // Keep fallback values when the URL cannot be parsed.
      }

      return { filterName: fallbackName, filterValue: fallbackValue };
    };

    sliderButtons.forEach((button) => {
      const { filterName, filterValue } = resolveFilterTarget(button);

      if (!filterName || !filterValue || filterName.startsWith("filter.")) {
        return;
      }

      const isActive = currentUrl.searchParams
        .getAll(filterName)
        .includes(filterValue);

      if (!isActive) {
        return;
      }

      const label =
        button.querySelector(".lcs-card__label")?.textContent?.trim() ||
        filterValue;

      customFilters.push({ filterName, filterValue, label });
    });

    const clearAllButton = track.querySelector("[data-clear-all]");
    customFilters.forEach(({ filterName, filterValue, label }) => {
      const chip = document.createElement("div");
      chip.className = "filter-chip-component";
      chip.setAttribute("data-component", "filter-chip");
      chip.setAttribute("data-filter-chip", "");
      chip.setAttribute("data-linked-filter-chip", "true");
      chip.setAttribute("data-filter-name", filterName);
      chip.setAttribute("data-filter-value", filterValue);

      const removeButton = document.createElement("button");
      removeButton.className = "filter-chip";
      removeButton.setAttribute("data-filter-remove", "");

      const labelNode = document.createElement("span");
      labelNode.className = "filter-chip__value body-small";
      labelNode.textContent = label;

      const iconNode = document.createElement("div");
      iconNode.className = "icon-l";
      iconNode.textContent = "x";

      removeButton.append(labelNode, iconNode);
      chip.appendChild(removeButton);

      if (clearAllButton) {
        track.insertBefore(chip, clearAllButton);
      } else {
        track.appendChild(chip);
      }
    });

    const allChips = this.querySelectorAll("[data-filter-chip]");
    this.setAttribute("data-active", allChips.length > 0);
    this.prunePriceChipIfNoPriceParams();
  }

  connectedCallback() {
    (document.addEventListener(r.FILTER_UPDATE, this.render.bind(this)),
      this.addEventListener("click", this.handleClearAllClick.bind(this)),
      this.addEventListener("click", this.handleRemoveClick),
      document.addEventListener(
        r.FILTERS_CLEAR_ALL,
        this.clearAllFilters.bind(this),
      ),
      this.syncCustomLinkedSliderChips());
  }
  disconnectedCallback() {
    (document.removeEventListener(r.FILTER_UPDATE, this.render.bind(this)),
      this.removeEventListener("click", this.handleClearAllClick.bind(this)),
      this.removeEventListener("click", this.handleRemoveClick),
      document.removeEventListener(
        r.FILTERS_CLEAR_ALL,
        this.clearAllFilters.bind(this),
      ));
  }
  handleRemoveClick(t) {
    if (t.target.closest("[data-filter-chip]")) {
      const e = t.target.closest("[data-filter-chip]");
      clearTimeout(this.timer);
      const i = new URL(window.location.href);
      (e.hasAttribute("data-filter-params")
        ? e
            .getAttribute("data-filter-params")
            .split(",")
            .forEach((l) => {
              i.searchParams.delete(l.trim());
            })
        : (() => {
            const l = e.getAttribute("data-filter-name"),
              o = e.getAttribute("data-filter-value"),
              h = i.searchParams.getAll(l).filter((d) => d !== o);
            i.searchParams.delete(l), h.forEach((d) => i.searchParams.append(l, d));
          })(),
        window.history.replaceState(null, "", i),
        e.remove(),
        document.dispatchEvent(new CustomEvent(r.FILTER_UPDATE)));
    }
  }
  handleClearAllClick(t) {
    t.target.closest("[data-clear-all]") && this.clearAllFilters();
  }
  clearAllFilters() {
    Array.from(this.children).forEach((e) => e.remove());
    const t = new URL(`${window.location.origin}${window.location.pathname}`);
    (window.history.replaceState(null, "", t),
      this.setAttribute("data-active", !1),
      document.dispatchEvent(new CustomEvent(r.FILTER_UPDATE)));
  }
  async render() {
    const t = new URL(window.location.href),
      e = await a.fetch(t, "main-product-grid"),
      i = n(e, "filter-chips");
    if (!i) return;
    const s = i.querySelectorAll("[data-filter-chip]");
    ((this.innerHTML = i.innerHTML),
      this.setAttribute("data-active", (s == null ? void 0 : s.length) > 0),
      this.syncCustomLinkedSliderChips());
  }
}
const E = () => {
  customElements.get("filter-chips") ||
    customElements.define("filter-chips", c);
};
E();
export { E as default };
